module.exports = __webpack_public_path__ + "static/areas_of_expertise.6e1ba69a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sections/images/areas_of_expertise.jpg
// module id = 509
// module chunks = 35783957827783